const DEFAULT_LOCALE = "en-us";

const getCountry = (locale = DEFAULT_LOCALE) => {
  const splitLocale = locale.split("-");
  if (splitLocale.length === 2) {
    return splitLocale[1];
  }

  throw new Error(
    `getCountry - Locale '${locale}' does not have a country code`,
  );
};

export { DEFAULT_LOCALE, getCountry };
